export default "__VITE_ASSET__DFo8Rkt___"